import { authenticatedApiFetch } from "./../../common/helpers";
import { call } from "actionware/lib/call";
import { onError, onSuccess } from "actionware/lib/listeners";
import { toggleConfirmationModal } from "../confirmationModal/confirmationModalActions";
import { BANNER_TYPE } from "./constants";

export async function fetchLenderPreferences() {
  return await authenticatedApiFetch(
    `lender/product_preferences`,
    "GET"
  ).then((result) => {
    return result.data;
  });
}

export function saveNewPreferenceData(action, data) {
  return { action, data };
}

export function resetToInitialState() {
  return;
}

export function toggleBannerView(data) {
  return data;
}

export function resetToggleBannerView() {
  return;
}

export async function persistNewPreferenceData(params) {
  return await authenticatedApiFetch(
    "lender/product_preferences",
    "PUT",
    params
  );
}

onSuccess(persistNewPreferenceData, (state, data) => {
  const isChecked = state.payload.data.auto_approval_enabled;
  call(toggleConfirmationModal);
  call(toggleBannerView, {
    showFlag: true,
    title: isChecked
      ? "autoApproval.lender_admin_snackbar_auto_approval_banner2"
      : "autoApproval.lender_admin_snackbar_auto_approval_turned_off",
    type: isChecked ? BANNER_TYPE.onBanner : BANNER_TYPE.offBanner,
  });
  call(fetchLenderPreferences);
});

onError(persistNewPreferenceData, (state, error) => {
  call(toggleConfirmationModal);
  call(toggleBannerView, {
    showFlag: true,
    title: "autoApproval.lender_admin_snackbar_auto_approval_banner1",
    type: BANNER_TYPE.disableBanner,
  });
});
